import { mobileRoutes } from "./routes.constants";

export interface MobileAppBuilderPageTabTypes {
    id: number;
    content: string;
    route: string;
}

export const NOTIFICATIONS_BANNERS_TAB = 1;
export const APPEARANCE_TAB = 2;
export const CUSTOM_MENU_TAB = 3;
export const MOBILE_SETUP_APP_TAB = 4;
export const SETUP_CUSTOMER_ACCOUNT_LOGIN_TAB = 5;

const NOTIFICATIONS_BANNERS_TAB_CONTENT = 'Notifications/Banners';
const APPEARANCE_TAB_CONTENT = 'Appearance';
const CUSTOM_MENU_TAB_CONTENT = 'Custom Menu';
const SETUP_MOBILE_APP_CONTENT = 'Setup Mobile App';
const SETUP_CUSTOMER_ACCOUNT_LOGIN_TAB_CONTENT = 'Setup Customer Account Login';

export const MOBILE_APP_BUILDER_PAGE_TABS: MobileAppBuilderPageTabTypes[] = [
    {
        id: NOTIFICATIONS_BANNERS_TAB,
        content: NOTIFICATIONS_BANNERS_TAB_CONTENT,
        route: mobileRoutes.notification,
    },
    {
        id: APPEARANCE_TAB,
        content: APPEARANCE_TAB_CONTENT,
        route: mobileRoutes.appearence,
    },
    {
        id: CUSTOM_MENU_TAB,
        content: CUSTOM_MENU_TAB_CONTENT,
        route: mobileRoutes.custom_menu,
    },
    {
        id: MOBILE_SETUP_APP_TAB,
        content: SETUP_MOBILE_APP_CONTENT,
        route: mobileRoutes.setup,
    },
    {
        id: SETUP_CUSTOMER_ACCOUNT_LOGIN_TAB,
        content: SETUP_CUSTOMER_ACCOUNT_LOGIN_TAB_CONTENT,
        route: mobileRoutes.setup_customer_account_login,
    },
];